import qs from 'qs'

import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`
interface SearchMaintenanceTicketsProps {
  keyword: string
  startCreatedDate?: string
  endCreatedDate?: string
  startModifiedDate?: string
  endModifiedDate?: string
  page: number
  size: number
  sort: string
  status: string
  methodOfRepairName: string
  typeOfConcernName: string
  purpose: string
  pageable: object
}

interface SearchAuditTrailProps {
  ticketId: number
  keyword?: string
  startCreatedDate?: string
  endCreatedDate?: string
  page: number
  size: number
  sort: string
  dataFilters?: string
  pageable?: object
}

// interface DealerProps {
//   page: Number
//   size: Number
//   sort: String[]
// }

interface BranchManagerProps {
  sourceUserId: number
}

interface ApproveOrDenyTicket {
  ticketId: number
  note: string
}

export const searchAllMaintenanceTicketsProcessing = async (
  params: SearchMaintenanceTicketsProps,
) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v2/ticket-view/search`,
      {
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
      },
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllMaintenanceTicketsProcessed = async (
  params: SearchMaintenanceTicketsProps,
) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v2/ticket-view/search`,
      {
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
      },
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllBranchManagerTickets = async (
  params: SearchMaintenanceTicketsProps,
) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v2/ticket-view/search`,
      {
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
      },
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllDealers = async () => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v2/branch/dealers`, )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllBranchDealers = async (dealerName: string) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v2/branch`, {
      params: { dealerName },
    })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const fileTicket = async (formDataPayload: FormData, role: string) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/ticket/${role}/filing`,
      formDataPayload,
      {
        headers: {
          accept: 'application/json',
        },
      },
    )

    return response
  } catch (error: any) {
    console.error('Error filing ticket', error)
    console.log('Error response:', error?.response?.data)
    console.log('Error status:', error?.response?.status)
    throw error
  }
}

export const updateFileTicket = async (
  formDataPayload: FormData,
  ticketId: number,
  dtoParam: any,
) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/ticket/update/by/bm/${ticketId}?isApprove=true&dto=${dtoParam}`,
      formDataPayload,
      {
        headers: {
          accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const updateFileTicketByAc = async (
  formDataPayload: FormData,
  ticketId: number,
  dtoParam: any,
) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/update/by/ac/${ticketId}?dto=${dtoParam}`,
      formDataPayload,
      {
        headers: {
          accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const updateFileTicketByMe = async (
  formDataPayload: any,
  ticketId: number,
  dtoParam: any,
) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/update/by/me/${ticketId}?dto=${dtoParam}`,
      formDataPayload,
      {
        headers: {
          accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const updateFileTicketByMa = async (ticketId: number, cost: number) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/update/by/ma/${ticketId}`,
      { amount: cost },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const updateFileTicketByWorkflow4Validation12 = async (
  ticketId: number,
  amount: number,
  dateOfApproval: string,
) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/update/by/ma/${ticketId}`,
      { dateOfApproval, amount, isSubmit: true },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const updateFileTicketRemovedByMa = async (
  ticketId: number,
  cost: number,
  retainAttachmentIds: number[],
) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/update/by/ma/${ticketId}`,
      {
        amount: cost,
        retainAttachmentIds,
      },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const removeFileTicket = async (
  ticketId: number,
  attachmentIds: number[],
) => {
  const query = attachmentIds.map((id) => `attachmentIds=${id}`).join('&')
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/attachment/ticket/soft-delete/${ticketId}?${query}`,
      {
        attachmentIds,
      },
    )
    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const fetchBranchManager = async (params: BranchManagerProps) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/branch/get/dealer/by/branch-manager/${params.sourceUserId}`,
      {},
    )

    return response
  } catch (error) {
    console.error('Error fetching branch manager', error)
    throw error
  }
}

export const denyTicket = async (data: ApproveOrDenyTicket) => {
  try {
    const response = await useAxios.put(`${DND_SERVICE}/v1/ticket/deny`, data )
    return response
  } catch (error) {
    console.error('Error denying ticket:', error)
    throw error
  }
}

export const softDeleteTicket = async (data: ApproveOrDenyTicket) => {
  try {
    const response = await useAxios.put(`${DND_SERVICE}/v1/ticket/soft-delete`, data)
    return response
  } catch (error) {
    console.error('Error deleting ticket:', error)
    throw error
  }
}

export const approveTicket = async (data: ApproveOrDenyTicket) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/approve`, data)
    return response
  } catch (error) {
    console.error('Error approving ticket:', error)
    throw error
  }
}

export const approveCoCTicket = async (ticketId: number, payload: any) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v2/ticket/update/by/ma/${ticketId}`, payload )
    return response
  } catch (error) {
    console.error('Error approving ticket:', error)
    throw error
  }
}

export const reviseTicket = async (data: ApproveOrDenyTicket) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/for-revision`, data )
    return response
  } catch (error) {
    console.error('Error revision ticket:', error)
    throw error
  }
}

export const searchTicketAuditTrail = async (params: SearchAuditTrailProps) => {
  const {
    ticketId,
    page,
    keyword,
    sort,
    startCreatedDate,
    endCreatedDate,
    dataFilters,
  } = params
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/audit-trail/ticket-history?ticketId=${ticketId}&size=999999&endCreatedDate=${endCreatedDate}&startCreatedDate=${startCreatedDate}&page=${page}&keyword=${keyword}&sort=${sort}&data=${dataFilters}`,
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchContractorQuotation = async (ticketId: number) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v1/ticket/contractor/quotation/${ticketId}?page=0&size=9999&sort=`,
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchPurchaseRequest = async (ticketId: number) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v1/ticket/purchase-request/quotation/${ticketId}?page=0&size=9999&sort=`,
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchPurchaseOrder = async (ticketId: number) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v1/ticket/purchase-order/quotation/${ticketId}?page=0&size=9999&sort=`,
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const submitContractorQuotation = async (formDataPayload: any) => {
  const { ticketId, retainContractorNames, isApprove, payload } =
    formDataPayload

  const formData = {
    requests: payload,
    retainContractorNames,
  }
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/ticket/attach/contractor/quotation/${ticketId}?&isApprove=${isApprove}`,
      formData,
      {
        headers: {
          accept: 'application/json',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const submitPurchaseRequest = async (formDataPayload: any) => {
  const { ticketId, retainPurchaseRequestNumbers, isApprove, payload } =
    formDataPayload

  const formData = {
    requests: payload,
    retainPurchaseRequestNumbers,
  }
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/ticket/attach/purchase-request/quotation/${ticketId}?&isApprove=${isApprove}`,
      formData,
      {
        headers: {
          accept: 'application/json',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const submitPurchaseOrder = async (formDataPayload: any) => {
  const { ticketId, isApprove, payload } = formDataPayload

  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/ticket/attach/purchase-order/quotation/${ticketId}?&isApprove=${isApprove}`,
      payload,
      {
        headers: {
          accept: 'application/json',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error filing ticket', error)
    throw error
  }
}

export const fetchRevisionUsers = async (ticketID: number) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v2/ticket-view/for-revision/user-selection`,
      {
        params: {
          ticketID,
        },
      },
    )
    console.log('this is response fetch revision users', response)
    return response
  } catch (error) {
    console.error('Error fetching users', error)
    throw error
  }
}

export const generatePdf = async (params: any) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v2/ticket-view/generate/pdf`,
      {
        params: {
          ...params,
        },
        responseType: 'blob',
      },
    )

    const blob = new Blob([response.data], { type: 'application/pdf' })

    const blobUrl = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = 'generated-report.pdf'

    link.click()

    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('Failed to generate PDF:', error)
    throw error
  }
}

export const generateCsv = async (params: any) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v2/ticket-view/generate/csv`,
      {
        params: {
          ...params,
        },
        responseType: 'blob',
      },
    )

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })

    const blobUrl = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = 'generated-report.csv'

    link.click()

    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('Failed to generate CSV:', error)
    throw error
  }
}

export const generatePdfById = async (id: number) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/ticket/summary/${id}`,
      {},
      {
        responseType: 'blob',
      },
    )

    const blob = new Blob([response.data], { type: 'application/pdf' })

    const blobUrl = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = `ticket-${id}.pdf`

    link.click()

    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error(`Failed to generate PDF for number ${id}:`, error)
    throw error
  }
}

export const recallByTicketId = async (ticketId: number | string) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/recall/${ticketId}`,
      {
        headers: {
          accept: 'application/json',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error Recalling Ticket', error)
    throw error
  }
}

export const onHoldByTicketId = async (
  ticketId: number | string,
  note: string,
) => {
  const payload = {
    ticketId: ticketId,
    note: note,
  }
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/mark/on-hold/${ticketId}`,
      payload,
      {
        headers: {
          accept: 'application/json',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error On Holding Ticket', error)
    throw error
  }
}

export const fetchTicketAttachments = async (
  ticketId: number,
  attachmentType: string,
) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/attachment/${ticketId}?page=0&size=1000&attachmentType=${attachmentType}`,
      {},
    )
    return response
  } catch (error) {
    console.error('Error fetching attachments', error)
    throw error
  }
}

export const uploadTicketAttachment = async (
  ticketId: number,
  attachmentType: string,
  file: File,
) => {
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await useAxios.post(
      `${DND_SERVICE}/v1/attachment/replace`,
      formData,
      {
        params: {
          ticketId,
          attachmentType,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response
  } catch (error) {
    console.error('Error uploading attachment', error)
    throw error
  }
}

export const updateDateApprovalAndGatePass = async (data: any) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/ticket/attach/date-of-approval/gate-pass`,
      data,
    )

    return response
  } catch (error) {
    console.error('Error uploading attachment', error)
    throw error
  }
}

export const getWorkflowFiveDetails = async (ticketId: number) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/ticket/details/${ticketId}`,
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getAttachment = async (fileName: string) => {
  try {
    const encodedFileName = encodeURIComponent(fileName);
    const response = await useAxios.get(
      `${DND_SERVICE}/v1/attachment/view?fileName=${encodedFileName}`
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const syncAllData = async () => {
  try {
    const response = await useAxios.post(`${DND_SERVICE}/v1/sync/all`)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
